import { createContext, useContext } from 'react';
import type { TableFileFormat } from './utils/tableExport';

/**
 * The title of the thread a message belongs to, which names the file a table of that message downloads
 * as. `AiChatMessage` provides it for a finished assistant answer on a surface that hands it a title.
 * `null`, the default, leaves a markdown table without its Download controls: while the answer streams, on a
 * user's message, and on a surface that keeps no thread to name the file after. A Figure keeps its Download
 * and names its file after the assistant then.
 */
const AiChatTableDownloadContext = createContext<string | null>(null);

export const AiChatTableDownloadProvider = AiChatTableDownloadContext.Provider;

export const useAiChatTableDownloadTitle = () => useContext(AiChatTableDownloadContext);

/**
 * A text block that answers a request for a file: the format asked, and the element at the top of the block,
 * above the heading of the table the request names, where that table draws its download card.
 */
export interface TableFileRequest {
    format: TableFileFormat;
    slot: HTMLElement;
}

const TableFileRequestContext = createContext<TableFileRequest | null>(null);

export const TableFileRequestProvider = TableFileRequestContext.Provider;

export const useTableFileRequest = () => useContext(TableFileRequestContext);
